import React from 'react';
import {getStoreByName} from 'client/framework';
import SettingsTable from 'sg/Tables/SettingsTable/SettingsTable.react';
import DownloadCSV from 'sg/Tables/SettingsTable/DownloadCSV.react';
import {Column} from 'sg/Tables/MandarkTable/MandarkTable.react';
import {sortDirections} from 'sg/Tables/tableConstants';
import ClassroomStatusFilters from '../Filters/ClassroomStatusFilters.react';
import ExpandSubjectsFilter from '../Filters/ExpandSubjectsFilter.react';
import EmptyUsageReport from './EmptyUsageReport.react';
import usageReportsStore from '../UsageReports.store';
import {
  getCountOfSchoolClassroomsContent,
  getCountOfSchoolTeachersContent,
  getCountOfSchoolAssignmentsContent,
  getSchoolSubjectsContent,
  getStudentAttemptsContent,
  getPerformanceBarContent,
  getCSVHeaders
} from './utils';

const usageReportStoreName = 'StudentUsageReportTableStore';
export default class StudentsReport extends React.Component {
  render() {
    const areSubjectsExpanded = usageReportsStore.areSubjectsExpanded();
    const mutator = (data) => {
      const searchTerm = getStoreByName(usageReportStoreName).getSearchTerm();
      return usageReportsStore.getStudentsExpandedSubjectsMutator(searchTerm)(data);
    };

    return (
      <SettingsTable
        title='Usage'
        topFilters={<ClassroomStatusFilters />}
        bottomFilters={<ExpandSubjectsFilter />}
        defaultSortDirection={sortDirections.DESCENDING}
        query={usageReportsStore.getStudentsQuery()}
        dataMutator={areSubjectsExpanded ? mutator : null}
        searchFilters={usageReportsStore.getStudentSearchFilters}
        storeName={usageReportStoreName}
        optionsMenu={
          <DownloadCSV
            csvQuery={usageReportsStore.getStudentsCSVQuery}
            tableStoreName={usageReportStoreName}
            fileName='students-usage-report'
            getCSVHeaders={getCSVHeaders('students')}
          />
        }
        className='usage-report__table'
        emptyTableElement={
          <EmptyUsageReport
            headerText={`You don't have any students!`}
            bodyText={`Students taught by teachers you've invited or approved will appear here.`}
          />
        }
      >
        <Column
          heading='Student'
          sortBy='last_name'
          alwaysVisible
          content={(student) => {
            return (
              <div className='usage-report__user-cell'>
                <span className='usage-report__user-name'>
                  {student.getFullName({formal: true})}
                </span>
                <span className='usage-report__user-email'>{student.getEmail()}</span>
              </div>
            );
          }}
        />
        <Column heading='Username' sortBy='username' content={(student) => student.getUsername()} />
        <Column
          heading='Teachers'
          sortBy={!areSubjectsExpanded ? 'meta.count_of_school_teachers' : null}
          defaultVisible
          className='sg-table__td--align-right'
          content={(student) => getCountOfSchoolTeachersContent(student, areSubjectsExpanded)}
        />
        <Column
          heading='Classes'
          sortBy={!areSubjectsExpanded ? 'meta.count_of_school_classrooms' : null}
          defaultVisible
          className='sg-table__td--align-right'
          content={(student) => getCountOfSchoolClassroomsContent(student, areSubjectsExpanded)}
        />
        <Column
          heading='Subjects'
          sortBy={!areSubjectsExpanded ? 'meta.school_subject_names' : null}
          defaultVisible
          className='usage-truncate-test'
          content={(student) => getSchoolSubjectsContent(student, areSubjectsExpanded)}
        />
        <Column
          defaultSortParam
          heading='Attempts'
          sortBy={!areSubjectsExpanded ? 'meta.count_of_school_guesses' : null}
          defaultVisible
          className='sg-table__td--align-right'
          content={(student) => getStudentAttemptsContent(student, areSubjectsExpanded)}
        />
        <Column
          heading='Assignments'
          sortBy={!areSubjectsExpanded ? 'meta.count_of_school_assignments' : null}
          className='sg-table__td--align-right'
          content={(student) => getCountOfSchoolAssignmentsContent(student, areSubjectsExpanded)}
        />
        <Column
          heading='Performance'
          content={(student) => getPerformanceBarContent(student, areSubjectsExpanded)}
        />
      </SettingsTable>
    );
  }
}
